import { Component, OnInit, ViewChild, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import { LoteDetalleUrlService } from 'src/app/core/services/lote-detalle-url.service';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { PlantillasService } from 'src/app/core/services/plantilla.service';
import { Plantilla } from 'src/app/models/Plantilla.model';
import { TableAction } from 'src/app/shared/components/table-paginator/table-paginator.component';
import { PlantillaCoordenada } from 'src/app/models/PlantillaCoordenada.model';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { PdfSanitizerService } from 'src/app/core/pdf-sanitizer.service';

interface Item {
    id?: number;
    url: string;
}
@Component({
    selector: 'subida-documento-plantilla-component',
    templateUrl: './subida-documento-plantilla.html',
    styleUrls: []
})

export class SubidaDocumentoPlantillaComponent implements OnInit {
    @Input() dataPlantilla: Plantilla;
    selectedFiles: File;
    public maxFile: number = 1;
    public maxFileSize = 40;
    public detalleShowDocument: Plantilla[] = [];
    public documentPdfUrl: SafeResourceUrl | null = null;

    public plantillaCoordenadas: PlantillaCoordenada[] = [];

    /* TABLE */


    currentItems: Item[] = []; // Los datos para la página actual
    spinner: boolean;
    tableHeaders = [
        { key: 'url', label: 'Url' },
    ];

    customActions: TableAction[] = [];
    @ViewChild('content') showDocumentReference!: TemplateRef<any>;

    // Toast
    toast = Swal;
    @Input() resolucionInicialActiva = false;

    @Output() stepRedirect = new EventEmitter<number>();

    constructor(
        private loteDetalleUrlService: LoteDetalleUrlService,
        private firmaStateService: FirmaStateService,
        private plantillasService: PlantillasService,
        private modalService: NgbModal,
        private sanitizer: DomSanitizer , 
        private pdfSanitizerService: PdfSanitizerService
    ) {

    }
    async ngOnInit() {

        this.toastAlert();
        this.customActions = [
            {
                label: 'Ver Documento',
                handler: (item: Item) => this.verDocumento(this.showDocumentReference, Number(item.id)),
                icon: 'fa-solid fa-eye',
                colorClass: 'bg-blue',
            },
            {
                label: 'Eliminar',
                handler: (item: Item) => this.eliminarDocumentoPlantilla(Number(item.id)),
                icon: 'fa-solid fa-trash-can',
                colorClass: 'bg-red',
            },
        ];

        await this.listCertificado();

        if (
            this.resolucionInicialActiva &&
            this.plantillaCoordenadas.length > 0
        ) {
            this.stepRedirect.emit(2);
            return;
        }
        if (this.dataPlantilla.id) {
            await this.precargarDataSubidaDocumento();
        }

    }

    async precargarDataSubidaDocumento() {
        await this.showDocumentPlantilla();
    }

    async showDocumentPlantilla() {
        const response = await lastValueFrom(this.plantillasService.showDocumenPlantilla(this.dataPlantilla.id));
        if (response.body.url) {
            this.detalleShowDocument = [response.body as Plantilla];
            this.currentItems = [response.body as Plantilla];
        } else {
            this.detalleShowDocument = [];
            this.currentItems = [];
        }
    }

    async eliminarDocumentoPlantilla(id: number) {

        if (this.plantillaCoordenadas.length <= 0) {
            Swal.fire({
                title: "¡Eliminación de Archivo!",
                text: "Deseas eliminar este archivo",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Eliminar",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {

                    await lastValueFrom(this.plantillasService.deleteDocumentPlantilla(id));
                    this.alert('success', 'Documento eliminado correctamente');
                    await this.showDocumentPlantilla();
                }
            });
        } else {
            this.alert(
                'warning',
                'Acción no permitida',
                'No se puede eliminar este documento porque tiene coordenadas asignadas'
            );
        }

    }

    handleFiles(files: any) {
        this.selectedFiles = files;
    }

    async subirDocumentos() {


        const formData = new FormData();

        const file = this.selectedFiles;
        formData.append('file', file, file.name);
        const response = await lastValueFrom(this.plantillasService.addDocumenPlantilla(this.dataPlantilla.id, formData));
        if (response) {

            this.alert(
                'success',
                'Documento guardado correctamente',
                'Haga clic en "Siguiente" para continuar con el proceso'
            );
            await this.showDocumentPlantilla();
            return response;
        }
    }

    public async validCantidadDocumentos(): Promise<boolean> {
        return (this.detalleShowDocument.length > 0) ? true : false;
    }

    async verDocumento(content: any, id: any) {
        const { body } = await lastValueFrom(
            this.plantillasService.viewDocumenPlantilla(id)
        );

        const safeUrl =
            this.pdfSanitizerService.getTrustedPdfUrl(body?.url_documento);

        if (!safeUrl) {
            this.alert('error', 'El documento no es válido');
            return;
        }

        this.documentPdfUrl = safeUrl;

        this.modalService.open(content, {
            centered: true,
            size: 'xl'
        });
    }

    async listCertificado() {
        const response = await lastValueFrom(this.plantillasService.getCordenadasPlantilla(this.dataPlantilla.id));
        this.plantillaCoordenadas = (response.body) as PlantillaCoordenada[];
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }
}